var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsDl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M15.75 10.125v4.5a.56.56 0 0 1-.562.563H2.813a.563.563 0 0 1-.563-.563v-4.5a.563.563 0 1 1 1.125 0v3.938h11.25v-3.938a.563.563 0 0 1 1.125 0m-7.148.398a.56.56 0 0 0 .796 0l2.813-2.813a.564.564 0 0 0-.796-.795L9.563 8.767V2.25a.563.563 0 1 0-1.126 0v6.517L6.586 6.915a.563.563 0 0 0-.795.795z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsDl);
export default __webpack_public_path__ + "static/media/actions-dl.b8645520e4e22a0ed7a26c26abfae256.svg";
export { ForwardRef as ReactComponent };